'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var sectionLayouts = {
  pageTitle: {
    sectionTitle: 'Page Title',
    sectionDescription: 'Displays a page title header',
    gridProps: {},
    layouts: [{
      definedComponentTypes: ['PageTitle'],
      componentLayouts: [{
        componentName: 'PageTitle',
        desktopWidth: 16,
        tabletWidth: 16,
        mobileWidth: 16,
        verticalAlign: 'middle',
        horizontalAlign: 'center',
        propFieldsMap: {
          pageTitle: 'title',
          pageTitleBackground: 'bgImage',
          pageTitleBackgroundColor: 'bgColor'
        }
      }]
    }]
  },
  contactInformation: {
    sectionTitle: 'Contact Information',
    sectionDescription: 'Displays business contact information',
    gridProps: {},
    layouts: [{
      definedComponentTypes: ['Email', 'Call'],
      componentLayouts: [{
        componentName: 'Email',
        desktopWidth: 8,
        tabletWidth: 16,
        mobileWidth: 16,
        verticalAlign: 'top',
        horizontalAlign: 'center',
        propFieldsMap: {
          email: 'email',
          emailBeforeText: 'beforeText',
          emailAfterText: 'afterText',
          emailShowIcon: 'showIcon',
          emailInlineIcon: 'inlineIcon'
        }
      }, {
        componentName: 'Call',
        desktopWidth: 8,
        tabletWidth: 16,
        mobileWidth: 16,
        verticalAlign: 'middle',
        horizontalAlign: 'center',
        propFieldsMap: {
          phone: 'number',
          callBeforeText: 'beforeText',
          callAfterText: 'afterText',
          callShowIcon: 'showIcon',
          callInlineIcon: 'inlineIcon'
        }
      }]
    }, {
      definedComponentTypes: ['Location', 'Call'],
      componentLayouts: [{
        componentName: 'Location',
        desktopWidth: 8,
        tabletWidth: 16,
        mobileWidth: 16,
        verticalAlign: 'middle',
        horizontalAlign: 'center',
        propFieldsMap: {
          address: 'address',
          businessName: 'name',
          locationBeforeText: 'beforeText',
          locationAfterText: 'afterText',
          locationShowMap: 'showMap',
          locationShowIcon: 'showIcon',
          locationInlineIcon: 'inlineIcon'
        }
      }, {
        componentName: 'Call',
        desktopWidth: 8,
        tabletWidth: 16,
        mobileWidth: 16,
        verticalAlign: 'middle',
        horizontalAlign: 'center',
        propFieldsMap: {
          phone: 'number',
          callBeforeText: 'beforeText',
          callAfterText: 'afterText',
          callShowIcon: 'showIcon',
          callInlineIcon: 'inlineIcon'
        }
      }]
    }, {
      definedComponentTypes: ['Location', 'Call', 'Contact'],
      componentLayouts: [{
        componentName: 'Call',
        desktopWidth: 16,
        tabletWidth: 16,
        mobileWidth: 16,
        verticalAlign: 'middle',
        horizontalAlign: 'center',
        propFieldsMap: {
          phone: 'number',
          callBeforeText: 'beforeText',
          callAfterText: 'afterText',
          callShowIcon: 'showIcon',
          callInlineIcon: 'inlineIcon'
        }
      }, {
        componentName: 'Location',
        desktopWidth: 8,
        tabletWidth: 16,
        mobileWidth: 16,
        verticalAlign: 'top',
        horizontalAlign: 'center',
        propFieldsMap: {
          address: 'address',
          businessName: 'name',
          locationBeforeText: 'beforeText',
          locationAfterText: 'afterText',
          locationShowMap: 'showMap',
          locationShowIcon: 'showIcon',
          locationInlineIcon: 'inlineIcon'
        }
      }, {
        componentName: 'Contact',
        desktopWidth: 8,
        tabletWidth: 16,
        mobileWidth: 16,
        verticalAlign: 'top',
        horizontalAlign: 'center',
        propFieldsMap: {
          contactSubscriptionCallback: 'subscriptionCallback',
          contactHeader: 'header',
          contactTOSLink: 'TOSlink',
          contactPPLink: 'PPLink',
          contactShowTextArea: 'showTextArea',
          contactTextAreaPlaceholder: 'textAreaPlaceholder',
          contactInline: 'inline'
        }
      }]
    }, {
      definedComponentTypes: ['Location', 'Call', 'Email'],
      componentLayouts: [{
        componentName: 'Call',
        desktopWidth: 16,
        tabletWidth: 16,
        mobileWidth: 16,
        verticalAlign: 'middle',
        horizontalAlign: 'center',
        propFieldsMap: {
          phone: 'number',
          callBeforeText: 'beforeText',
          callAfterText: 'afterText',
          callShowIcon: 'showIcon',
          callInlineIcon: 'inlineIcon'
        }
      }, {
        componentName: 'Email',
        desktopWidth: 8,
        tabletWidth: 16,
        mobileWidth: 16,
        verticalAlign: 'top',
        horizontalAlign: 'center',
        propFieldsMap: {
          email: 'email',
          emailBeforeText: 'beforeText',
          emailAfterText: 'afterText',
          emailShowIcon: 'showIcon',
          emailInlineIcon: 'inlineIcon'
        }
      }, {
        componentName: 'Location',
        desktopWidth: 16,
        tabletWidth: 16,
        mobileWidth: 16,
        verticalAlign: 'top',
        horizontalAlign: 'center',
        propFieldsMap: {
          address: 'address',
          businessName: 'name',
          locationBeforeText: 'beforeText',
          locationAfterText: 'afterText',
          locationShowMap: 'showMap',
          locationShowIcon: 'showIcon',
          locationInlineIcon: 'inlineIcon'
        }
      }]
    }, {
      definedComponentTypes: ['Location', 'Call', 'Hoo'],
      componentLayouts: [{
        componentName: 'Call',
        desktopWidth: 16,
        tabletWidth: 16,
        mobileWidth: 16,
        verticalAlign: 'middle',
        horizontalAlign: 'center',
        propFieldsMap: {
          phone: 'number',
          callBeforeText: 'beforeText',
          callAfterText: 'afterText',
          callShowIcon: 'showIcon',
          callInlineIcon: 'inlineIcon'
        }
      }, {
        componentName: 'Location',
        desktopWidth: 8,
        tabletWidth: 16,
        mobileWidth: 16,
        verticalAlign: 'top',
        horizontalAlign: 'center',
        propFieldsMap: {
          address: 'address',
          businessName: 'name',
          locationBeforeText: 'beforeText',
          locationAfterText: 'afterText',
          locationShowMap: 'showMap',
          locationShowIcon: 'showIcon',
          locationInlineIcon: 'inlineIcon'
        }
      }, {
        componentName: 'Hoo',
        desktopWidth: 8,
        tabletWidth: 16,
        mobileWidth: 16,
        verticalAlign: 'top',
        horizontalAlign: 'center',
        propFieldsMap: {
          hoo: 'hours',
          timezone: 'timezone',
          showHours: 'showHours',
          hooShowIcon: 'showIcon',
          hooInline: 'inline'
        }
      }]
    }, {
      definedComponentTypes: ['Location', 'Call', 'Contact', 'Hoo'],
      componentLayouts: [{
        componentName: 'Contact',
        desktopWidth: 8,
        tabletWidth: 16,
        mobileWidth: 16,
        verticalAlign: 'top',
        horizontalAlign: 'center',
        propFieldsMap: {
          contactSubscriptionCallback: 'subscriptionCallback',
          contactHeader: 'header',
          contactTOSLink: 'TOSlink',
          contactPPLink: 'PPLink',
          contactShowTextArea: 'showTextArea',
          contactTextAreaPlaceholder: 'textAreaPlaceholder',
          contactInline: 'inline'
        }
      }, {
        componentName: 'Call',
        desktopWidth: 8,
        tabletWidth: 16,
        mobileWidth: 16,
        verticalAlign: 'top',
        horizontalAlign: 'center',
        propFieldsMap: {
          phone: 'number',
          callBeforeText: 'beforeText',
          callAfterText: 'afterText',
          callShowIcon: 'showIcon',
          callInlineIcon: 'inlineIcon'
        }
      }, {
        componentName: 'Hoo',
        desktopWidth: 8,
        tabletWidth: 16,
        mobileWidth: 16,
        verticalAlign: 'top',
        horizontalAlign: 'center',
        propFieldsMap: {
          hoo: 'hours',
          timezone: 'timezone',
          showHours: 'showHours',
          hooShowIcon: 'showIcon',
          hooInline: 'inline'
        }
      }, {
        componentName: 'Location',
        desktopWidth: 8,
        tabletWidth: 16,
        mobileWidth: 16,
        verticalAlign: 'top',
        horizontalAlign: 'center',
        propFieldsMap: {
          address: 'address',
          businessName: 'name',
          locationBeforeText: 'beforeText',
          locationAfterText: 'afterText',
          locationShowMap: 'showMap',
          locationShowIcon: 'showIcon',
          locationInlineIcon: 'inlineIcon'
        }
      }]
    }, {
      definedComponentTypes: ['Location', 'Call', 'Email', 'Hoo'],
      componentLayouts: [{
        componentName: 'Email',
        desktopWidth: 8,
        tabletWidth: 16,
        mobileWidth: 16,
        verticalAlign: 'top',
        horizontalAlign: 'center',
        propFieldsMap: {
          email: 'email',
          emailBeforeText: 'beforeText',
          emailAfterText: 'afterText',
          emailShowIcon: 'showIcon',
          emailInlineIcon: 'inlineIcon'
        }
      }, {
        componentName: 'Call',
        desktopWidth: 8,
        tabletWidth: 16,
        mobileWidth: 16,
        verticalAlign: 'top',
        horizontalAlign: 'center',
        propFieldsMap: {
          phone: 'number',
          callBeforeText: 'beforeText',
          callAfterText: 'afterText',
          callShowIcon: 'showIcon',
          callInlineIcon: 'inlineIcon'
        }
      }, {
        componentName: 'Hoo',
        desktopWidth: 8,
        tabletWidth: 16,
        mobileWidth: 16,
        verticalAlign: 'top',
        horizontalAlign: 'center',
        propFieldsMap: {
          hoo: 'hours',
          timezone: 'timezone',
          showHours: 'showHours',
          hooShowIcon: 'showIcon',
          hooInline: 'inline'
        }
      }, {
        componentName: 'Location',
        desktopWidth: 8,
        tabletWidth: 16,
        mobileWidth: 16,
        verticalAlign: 'top',
        horizontalAlign: 'center',
        propFieldsMap: {
          address: 'address',
          businessName: 'name',
          locationBeforeText: 'beforeText',
          locationAfterText: 'afterText',
          locationShowMap: 'showMap',
          locationShowIcon: 'showIcon',
          locationInlineIcon: 'inlineIcon'
        }
      }]
    }]
  },
  socialMedia: {
    sectionTitle: 'Social Media',
    sectionDescription: 'Display Social Media Links',
    gridProps: {},
    layouts: [{
      definedComponentTypes: ['Title', 'SocialMedia'],
      componentLayouts: [{
        componentName: 'Title',
        desktopWidth: 16,
        tabletWidth: 16,
        mobileWidth: 16,
        verticalAlign: 'middle',
        horizontalAlign: 'center',
        propFieldsMap: {
          socialMediaTitle: 'title',
          socialMediaTitleBackgroundColor: 'bgColor'
        }
      }, {
        componentName: 'SocialMedia',
        desktopWidth: 16,
        tabletWidth: 16,
        mobileWidth: 16,
        verticalAlign: 'middle',
        horizontalAlign: 'center',
        propFieldsMap: {
          socialMediaLinks: 'socialMediaConfig'
        }
      }]
    }, {
      definedComponentTypes: ['SocialMedia'],
      componentLayouts: [{
        componentName: 'SocialMedia',
        desktopWidth: 16,
        tabletWidth: 16,
        mobileWidth: 16,
        verticalAlign: 'middle',
        horizontalAlign: 'center',
        propFieldsMap: {
          socialMediaLinks: 'socialMediaConfig'
        }
      }]
    }]
  },
  businessDescription: {
    sectionTitle: 'Business Description',
    sectionDescription: 'About a business copy',
    gridProps: {},
    layouts: [{
      definedComponentTypes: ['Title'],
      componentLayouts: [{
        componentName: 'Title',
        desktopWidth: 16,
        tabletWidth: 16,
        mobileWidth: 16,
        verticalAlign: 'middle',
        horizontalAlign: 'center',
        propFieldsMap: {
          businessDescriptionTitle: 'title',
          businessDescriptionTitleBackgroundColor: 'bgColor'
        }
      }]
    }, {
      definedComponentTypes: ['Tagline'],
      componentLayouts: [{
        componentName: 'Tagline',
        desktopWidth: 16,
        tabletWidth: 16,
        mobileWidth: 16,
        verticalAlign: 'middle',
        horizontalAlign: 'center',
        propFieldsMap: {
          businessDescriptionTitle: 'headerText',
          businessTagline: 'tagline'
        }
      }]
    }]
  },
  reviews: {
    sectionTitle: 'Reviews',
    sectionDescription: 'Display business customer reviews',
    gridProps: {},
    layouts: [{
      definedComponentTypes: ['Title', 'Reviews'],
      componentLayouts: [{
        componentName: 'Title',
        desktopWidth: 16,
        tabletWidth: 16,
        mobileWidth: 16,
        verticalAlign: 'middle',
        horizontalAlign: 'center',
        propFieldsMap: {
          businessReviewsTitle: 'title',
          businessReviewsTitleBackgroundColor: 'bgColor'
        }
      }, {
        componentName: 'Reviews',
        desktopWidth: 16,
        tabletWidth: 16,
        mobileWidth: 16,
        verticalAlign: 'middle',
        horizontalAlign: 'center',
        propFieldsMap: {
          businessReviews: 'reviews',
          businessReviewsLink: 'reviewsLink'
        }
      }]
    }, {
      definedComponentTypes: ['Reviews'],
      componentLayouts: [{
        componentName: 'Reviews',
        desktopWidth: 16,
        tabletWidth: 16,
        mobileWidth: 16,
        verticalAlign: 'middle',
        horizontalAlign: 'center',
        propFieldsMap: {
          businessReviews: 'reviews',
          businessReviewsLink: 'reviewsLink'
        }
      }]
    }]
  },
  imageGallery: {
    sectionTitle: 'Image Gallery',
    sectionDescription: 'Display a businesses image gallery',
    gridProps: {},
    layouts: [{
      definedComponentTypes: ['Title', 'ImageGallery'],
      componentLayouts: [{
        componentName: 'Title',
        desktopWidth: 16,
        tabletWidth: 16,
        mobileWidth: 16,
        verticalAlign: 'middle',
        horizontalAlign: 'center',
        propFieldsMap: {
          businessImagesTitle: 'title',
          businessImagesTitleBackgroundColor: 'bgColor'
        }
      }, {
        componentName: 'ImageGallery',
        desktopWidth: 16,
        tabletWidth: 16,
        mobileWidth: 16,
        verticalAlign: 'middle',
        horizontalAlign: 'center',
        propFieldsMap: {
          images: 'images',
          isInstagram: 'isInstagram',
          instagramLink: 'link',
          imagesPerRow: 'imagesPerRow'
        }
      }]
    }, {
      definedComponentTypes: ['ImageGallery'],
      componentLayouts: [{
        componentName: 'ImageGallery',
        desktopWidth: 16,
        tabletWidth: 16,
        mobileWidth: 16,
        verticalAlign: 'middle',
        horizontalAlign: 'center',
        propFieldsMap: {
          images: 'images',
          isInstagram: 'isInstagram',
          instagramLink: 'link',
          imagesPerRow: 'imagesPerRow'
        }
      }]
    }]
  }
};

exports.default = sectionLayouts;

// add in additional props for all components


//////////////////
// WEBPACK FOOTER
// ./~/@fishrmn/fishrmn-types/build/types/sectionLayoutTypes.js
// module id = 517
// module chunks = 168707334958949